export const activityRoutes = {
  path: "",
  name: "reports",
  component: () => import("@/layouts/Main.vue"),
  rule: "editor",
  children: [
    {
      path: "/activity-reports",
      name: "activity",
      component: () => import("@/views/reports/activity/ActivityView.vue"),
      meta: {
        breadcrumb: [
          { title: "Home", url: "/" },
          { title: "reports" },
          { title: "Activity Reports", active: true },
        ],
        pageTitle: "Activity Reports",
        rule: "editor",
        no_scroll: true,
      },
    },
    {
      path: "/ifta-reports",
      name: "ifta",
      component: () => import("@/views/reports/Ifta/IftaView.vue"),
      meta: {
        breadcrumb: [
          { title: "Home", url: "/" },
          { title: "reports" },
          { title: "IFTA Reports", active: true },
        ],
        pageTitle: "IFTA Reports",
        rule: "editor",
        no_scroll: true,
      },
    },
    {
      path: "/driver-reports",
      name: "Driver",
      component: () => import("@/views/reports/driver/DriverView.vue"),
      meta: {
        breadcrumb: [
          { title: "Home", url: "/" },
          { title: "reports" },
          { title: "Driver", active: true },
        ],
        pageTitle: "Driver",
        rule: "editor",
        no_scroll: true,
      },
    },
    {
      path: "/fmcsa-reports",
      name: "Fmcsa",
      component: () => import("@/views/reports/fmcsa/FmcsaView.vue"),
      meta: {
        breadcrumb: [
          { title: "Home", url: "/" },
          { title: "reports" },
          { title: "FMCSA Reports", active: true },
        ],
        pageTitle: "FMCSA Reports",
        rule: "editor",
        no_scroll: true,
      },
    },
  ],
};
